module.exports = __webpack_public_path__ + "static/media/Desktop_Numbers.df032c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Desktop_Numbers.png
// module id = 100
// module chunks = 0